@if (verifyResult$ | glxyAsyncStatus | async; as result) {
  @switch (result.status) {
    @case ('loading') {
      <glxy-loading-spinner [size]="'small'" [fullWidth]="false"></glxy-loading-spinner>
    }
    @case ('error') {
      <mat-icon>warning</mat-icon>
    }
    @default {
      <div class="status-and-domain" (click)="handleClick('value' in result ? result.value : null)">
        <email-domain-status-icon [result]="'value' in result ? result.value : null"></email-domain-status-icon>
        {{ domain.sendFromDomain }}
      </div>
    }
  }
}
